export const BASE_URL = process.env.REACT_APP_BASE_URL ?? 'https://integ.lili.co/lili';
export const ASSETS_BASE_URL = 'https://assets.lili.co';
export const USER = {
  BASE: 'api/{version}/user', // 'v1'
  CONTROLLERS: {
    SECURITY: {
      BASE: 'openauth',
      VERSION: 'v1',
      ROUTES: {
        VERIFY: {
          BASE: 'login/mfa',
          VARIABLES: { CUSTOMER: '{customerId}', AUTHID: '{authUserId}' },
          SUB_ROUTES: { RESEND: 'resend' },
        },
        LOGIN: {
          BASE: 'login',
        },
      },
    },
    PLAID: {
      ROUTES: {
        GENERATE: {
          BASE: 'linkToken/ACH',
          VERSION: 'v1',
          VARIABLES: { CUSTOMER: '{customerId}' },
        },
        LINKED_ACCOUNTS: {
          BASE: 'link',
          VERSION: 'v1',
          VARIABLES: { CUSTOMER: '{customerId}' },
        },
      },
    },
    ACCOUNT: {
      BASE: 'account',
      ROUTES: {
        TRANSACTIONS: {
          VERSION: 'v2',
          BASE: 'transactions',
          VARIABLES: { CUSTOMER: '{customerId}' },
          SUB_ROUTES: { CATEGORIES: { BASE: 'categories', VERSION: 'v2' } },
        },
        SUMMARY: {
          VERSION: 'v2',
          BASE: 'summary',
          VARIABLES: { CUSTOMER: '{customerId}' },
        },
      },
    },
    EMERGENCY_BUCKET_TRANSACTIONS: {
      VERSION: 'v1',
      BASE: 'bucket/emergency/transactions',
    },
    TAX_BUCKET_TRANSACTIONS: {
      VERSION: 'v1',
      BASE: 'tax/transactions',
    },
    TAX_BUCKET_INFO: {
      VERSION: 'v1',
      BASE: 'taxInfo',
    },
    ESTIMATED_TAX_RATE: {
      VERSION: 'v1',
      BASE: 'tax',
    },
    RECEIPT: {
      VARIABLES: {
        CUSTOMER: '{customerId}',
        TRANSACTION_ID: '{transactionId}',
      },
      VERSION: 'v1',
      BASE: 'account/transactions',
    },
    COMMENT: {
      VERSION: 'v1',
      BASE: 'account/transactions',
    },
    CHECK: {
      VERSION: 'v2',
      BASE: 'check',
      FRONT_SIDE: 'front',
      REAR_SIDE: 'rear',
    },
    STATEMENTS: {
      VERSION: 'v3',
      BASE: 'statements',
    },
    EXPENSES: {
      VERSION: 'v1',
      BASE: 'taxStatements',
    },
    GET_DIRECT_DEPOSIT_FORM: {
      VERSION: 'v1',
      BASE: 'confirmation/bankAccount/download',
    },
    SCHEDULE_UNCATEGORIZED_DATA: {
      VERSION: 'v2',
      BASE: 'home/uncategorized',
    },
    SCHEDULE_DATA: {
      VERSION: 'v1',
      BASE: 'scheduleC',
    },
    SCHEDULE_INCOME: {
      VERSION: 'v1',
      BASE: 'income',
    },
    SCHEDULE_CREATE_FORM: {
      VERSION: 'v1',
      BASE: 'scheduleC',
      END: 'create',
    },
    SCHEDULE_DOWNLOAD_DOC: {
      VERSION: 'v1',
      BASE: 'scheduleC',
    },
    DASHBOARD_HOME: {
      VERSION: 'v5',
      BASE: 'home',
    },
    INITIALIZE_API: {
      LOGIN_VERSION: 'v2',
      CARD_VERSION: 'v4',
      LOGIN_BASE: 'initialize',
      CARD_BASE: 'features',
    },
    GET_URL_TO_CHANGE_PIN: {
      VERSION: 'v1',
      BASE: 'card',
      END: 'pin/start',
    },
    FINISH_SET_PIN: {
      VERSION: 'v1',
      BASE: 'card',
      SUCCESS_QUERY: '/pin/finish/?status=0',
      FAILURE_QUERY: '/pin/finish/?status=10',
    },
    CARD_FREEZE: {
      VERSION: 'v1',
      BASE: 'card',
      LOCK: 'lock',
      UNLOCK: 'unlock',
    },
    TAX_ESTIMATION: {
      VERSION: 'v1',
      BASE: 'account/tax/estimate',
    },
    TOGGLE_AUTO_SAVING: {
      VERSION: 'v1',
      BASE: 'bucket/emergency/autoSave',
    },
    SET_UP_AUTO_SAVINGS: {
      VERSION: 'v1',
      BASE: 'bucket/emergency',
    },
    UPDATE_ADDRESS: {
      VERSION: 'v1',
      BASE: 'address',
    },
    MOVE_FROM_EMERGENCY_BUCKET: {
      VERSION: 'v1',
      BASE: 'bucket/emergency/move',
    },
    MOVE_FROM_TAX_BUCKET: {
      VERSION: 'v1',
      BASE: 'tax/move',
    },
    APP_CENTER: {
      VERSION: 'v1',
      BASE: 'appcenter',
    },
    ACTIVATE_CARD: {
      VERSION: 'v1',
      BASE: 'card',
      TYPE_SSN: 'activate',
      TYPE_EXP_DATE: 'activateReissued',
    },
    CASH_DEPOSIT: {
      VERSION: 'v1',
      BASE: 'cashDeposit',
    },
    ORDER_NEW_CARD: {
      VERSION: 'v2',
      BASE: 'card',
    },
    LOGOUT: {
      VERSION: 'v1',
      BASE: 'logout',
    },
    CUSTOM_LOGO: {
      VERSION: 'v2',
      BASE: 'invoice/logo',
    },
    DOWNLOAD_INVOICE: {
      VERSION: 'v2',
      BASE: 'public/invoice',
    },
    CANCEL_INVOICE: {
      VERSION: 'v1',
      BASE: 'user',
    },
    ADD_INVOICE_PAYMENT: {
      VERSION: 'v1',
      BASE: 'user',
    },
    MARK_AS_PAID: {
      VERSION: 'v1',
      BASE: 'user',
    },
    MARK_AS_UNPAID: {
      VERSION: 'v1',
      BASE: 'user',
    },
  },
};

export const GOOGLE_MAPS = {
  MAPS_STATIC_MAP_BASE_URL: 'https://maps.google.com/maps/api/staticmap?',
  PLACE_PHOTO_BASE_URL: 'https://maps.googleapis.com/maps/api/place/photo?',
  MAP_WEB_VIEW_URL: 'https://maps.google.com/maps?q=latitude,longitude',
};
